
import { Button } from "@/components/ui/button";

export function Hero() {
  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center bg-background overflow-hidden pt-20 transition-colors duration-300"
    >
      {/* Background Image Estática */}
      <div
        className="absolute inset-0 bg-cover bg-center brightness-75 dark:brightness-100 opacity-95 dark:opacity-100 transition-all duration-300"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1568901346375-23c9450c58cd?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&h=1300&q=80')",
        }}
      />
      {/* Overlay adaptativo para light e dark */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-white/35 to-background/90 dark:from-black/50 dark:via-black/70 dark:to-black/95 transition-all duration-300" />

      <div className="container relative z-10 mx-auto px-4 sm:px-6 py-20 md:py-16">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto animate-fade-in">
          <div className="mb-8 relative mt-8">
            <img
              src="/lovable-uploads/93e5cd42-eca6-41a9-92d5-35b49e1d113f.png"
              alt="K-recão Lanches Logo"
              className="h-24 sm:h-32 md:h-40 relative drop-shadow-[0_0_15px_rgba(253,212,15,0.3)]"
            />
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-foreground leading-tight drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
            <span className="text-krecao-yellow font-extrabold [text-shadow:_0_2px_4px_rgba(0,0,0,0.7)]">O Melhor</span> lanche da{" "}
            <span className="text-krecao-red font-extrabold">zona sul</span>
          </h1>

          <p className="mt-4 sm:mt-6 text-base sm:text-xl text-gray-800 dark:text-gray-300 max-w-xl px-4 sm:px-0 font-medium drop-shadow-[0_1px_2px_rgba(255,255,255,0.9)] dark:drop-shadow-md">
            Experimente os melhores lanches da cidade. Do clássico ao gourmet,
            temos uma variedade de opções para satisfazer seu paladar.
          </p>

          <div className="mt-8 sm:mt-10 flex flex-col gap-4 w-full max-w-md px-4 sm:px-0">
            <Button
              className="bg-krecao-red hover:bg-krecao-red/90 text-white rounded-full px-6 sm:px-8 py-6 sm:py-7 text-base sm:text-lg w-full shadow-[0_0_20px_rgba(235,1,1,0.4)] transition-all hover:scale-[1.02]"
              onClick={() =>
                window.open(
                  "https://www.ifood.com.br/delivery/porto-alegre-rs/k-recao-lanches--grelhados-e-porcoes-cristal/6275accc-4883-446b-8359-d98bcc367615?srsltid=AfmBOoqBB8HG_-HUE2-8McvH9CSGuQ2QuLsGlnnVCPGkDYm0kNCNCdZi",
                  "_blank"
                )
              }
            >
              Pedir no iFood
            </Button>
            <Button
              onClick={() =>
                window.open(
                  "https://wa.me/5132422047?text=Olá! Gostaria de fazer um pedido no K-recão Lanches.",
                  "_blank"
                )
              }
              className="bg-[#25D366] hover:bg-[#20bd5a] text-white rounded-full px-6 sm:px-8 py-6 sm:py-7 text-base sm:text-lg w-full shadow-[0_0_20px_rgba(37,211,102,0.3)] transition-all hover:scale-[1.02]"
            >
              Pedir no WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
